import { render } from "./package-info.vue?vue&type=template&id=7df91238&scoped=true"
import script from "./package-info.ts?vue&type=script&lang=ts"
export * from "./package-info.ts?vue&type=script&lang=ts"

import "./package-info.css?vue&type=style&index=0&id=7df91238&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7df91238"

export default script